const scheduleOptions = {
    SCHEDULED: 'Scheduled',
    NO_SCHEDULING: 'No Scheduling',
};

export default scheduleOptions;
